module.exports = __webpack_public_path__ + "img/remove_section.3dbb55f7.svg";